var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.956,
    x2: 388.026,
    xlinkHref: "#lg1",
    y1: 19.739,
    y2: 178.809
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.482,
    x2: 113.666,
    xlinkHref: "#lg2",
    y1: 179.178,
    y2: 248.363
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.177,
    x2: 254.747,
    xlinkHref: "#lg3",
    y1: 55.267,
    y2: 148.837
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.832,
    x2: 483.7,
    xlinkHref: "#lg4",
    y1: 122.614,
    y2: 274.483
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.57,
    x2: 453.611,
    xlinkHref: "#lg5",
    y1: 259.66,
    y2: 347.701
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.372,
    x2: 135.969,
    xlinkHref: "#lg6",
    y1: 270.376,
    y2: 373.973
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.831,
    x2: 341.741,
    xlinkHref: "#lg7",
    y1: 389.528,
    y2: 476.437
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.478,
    x2: 316.633,
    xlinkHref: "#lg8",
    y1: 344.481,
    y2: 554.637
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.702,
    x2: 362.367,
    xlinkHref: "#lg1",
    y1: 73.556,
    y2: 194.221
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.639,
    x2: 36.299,
    xlinkHref: "#lg2",
    y1: 263.29,
    y2: 141.95
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.503,
    x2: 134.517,
    xlinkHref: "#lg3",
    y1: 165.639,
    y2: 57.652
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.365,
    x2: 322.367,
    xlinkHref: "#lg4",
    y1: 268.219,
    y2: 154.221
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.506,
    x2: 352.346,
    xlinkHref: "#lg5",
    y1: 351.642,
    y2: 275.481
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.562,
    x2: 46.948,
    xlinkHref: "#lg6",
    y1: 384.494,
    y2: 243.88
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.317,
    x2: 238.827,
    xlinkHref: "#lg7",
    y1: 446.968,
    y2: 344.478
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.313,
    x2: 132.233,
    xlinkHref: "#lg8",
    y1: 454.246,
    y2: 329.165
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.144,
    x2: 368.938,
    y1: 202.926,
    y2: 159.721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.579,
    x2: 374.431,
    xlinkHref: "#lg1",
    y1: 22.785,
    y2: 167.637
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m425.135 99.259-94.513 94.513c-19.356-19.356-46.094-31.33-75.622-31.33v-133.655c66.438 0 126.598 26.924 170.135 70.472z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.538 193.771c-19.356 19.356-29.954 41.951-29.954 71.479l-66.226 4.143h-64.965c0-66.438 26.924-126.598 70.472-170.135l46.661 46.661z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 28.787v133.655c-29.528 0-56.266 11.974-75.622 31.33l-94.513-94.513c43.537-43.548 103.697-70.472 170.135-70.472z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.607 269.393h-133.655c0-29.528-11.974-56.266-31.33-75.622l94.513-94.513c43.548 43.537 70.472 103.697 70.472 170.135z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.607 269.393c0 66.438-26.924 126.598-70.472 170.135l-94.513-94.513c19.356-19.356 31.33-46.094 31.33-75.622z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.378 345.015-94.513 94.513c-43.548-43.536-70.472-103.697-70.472-170.135h133.655c0 29.528 11.974 56.266 31.33 75.622z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.135 439.528c-43.537 43.548-103.697 70.472-170.135 70.472v-133.655c29.528 0 56.266-11.974 75.622-31.33z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 376.345v133.655c-66.438 0-126.598-26.924-170.135-70.472l94.513-94.513c19.356 19.356 46.094 31.33 75.622 31.33z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m384.063 140.33-53.441 53.441c-19.356-19.356-46.094-31.33-75.622-31.33v-75.563c50.407 0 96.024 20.425 129.063 53.452z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.378 193.771c-19.356 19.356-31.33 46.094-31.33 75.622h-75.564c0-50.407 20.425-96.024 53.453-129.063z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 86.878v75.564c-29.528 0-56.266 11.974-75.622 31.33l-53.441-53.441c33.039-33.028 78.656-53.453 129.063-53.453z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.516 269.393h-75.564c0-29.528-11.974-56.266-31.33-75.622l53.441-53.441c33.027 33.039 53.453 78.656 53.453 129.063z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.516 269.393c0 50.407-20.426 96.024-53.453 129.063l-53.441-53.441c19.356-19.356 31.33-46.094 31.33-75.622z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.378 345.015-53.441 53.441c-33.027-33.039-53.453-78.656-53.453-129.063h75.564c0 29.528 11.974 56.266 31.33 75.622z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.063 398.456c-33.039 33.027-78.656 53.453-129.063 53.453v-75.564c29.528 0 56.266-11.974 75.622-31.33z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 376.345v75.564c-50.407 0-96.024-20.426-129.063-53.453l53.441-53.441c19.356 19.356 46.094 31.33 75.622 31.33z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m495.607 269.393h-133.655c0-29.528-11.974-56.266-31.33-75.622l94.513-94.513c43.548 43.537 70.472 103.697 70.472 170.135z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.734 108.652-101.97 101.97c-6.776 6.776-17.52 7.294-25.029 1.34-20.686-16.4-45.95-27.275-73.559-30.393-9.406-1.062-16.446-9.151-16.446-18.617v-144.192c0-10.841 9.16-19.379 19.981-18.725 75.105 4.537 143.364 34.482 196.269 81.365 8.062 7.144 8.369 19.636.754 27.252z",
    fill: "url(#SVGID_18_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRgb);
export default __webpack_public_path__ + "static/media/icon-rgb.d4b099b8b8135d64a1cb67f567223628.svg";
export { ForwardRef as ReactComponent };